// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + (chunkId === 852 ? "hero-scene" : chunkId) + "." + {"155":"80a17529","228":"8113bc5d","404":"24fbd46b","408":"ddd8cb10","518":"db28936a","679":"4a4b37b7","698":"b841bf3c","852":"6670e93a"}[chunkId] + ".chunk.js";
};